import { useEffect, useState } from "react";
import { IUseLoginProps } from "./types";
import { useLoginMutation } from "../providers/Auth";

const useLogin = ({ onError, clearErrors }: IUseLoginProps) => {
  const [signInPayload, setSignInPayload] = useState<any>();
  const { mutate: loginMutation, error: loginError } = useLoginMutation();
  const [isLoading, setIsLoading] = useState(false);

  loginMutation(signInPayload!, {
    onError: (error) => {
      setSignInPayload(undefined);
      setIsLoading(false);
    },
  });

  // Start loading state only if useGetUserPoolInfoQuery start fetching userData
  useEffect(() => {
    if (signInPayload?.username) {
      setIsLoading(true);
    }
  }, [signInPayload]);

  // const login = (payload: ILoginVariables) => {
  //   setSignInPayload(payload);
  // };

  const isError = loginError;
  // Allow parent component to track error occurrence
  useEffect(() => {
    if (isError) {
      onError();
    } else {
      clearErrors();
    }
  }, [isError]);

  return {
    // login,
    isLoading,
    error: isError,
  };
};

export default useLogin;
